import React, { useState, useEffect } from 'react';
import { Grid, Icon, IconButton, makeStyles } from '@material-ui/core';

const QrCodeThumb = ({url, onClick, size}) => {

    const classes = useStyles()

    const _size = size ? size : 512
    return ( 
        <div className={classes.root} onClick={onClick}>
            {url 
            ? (
                <div className={classes.image_container}><img src={url} alt='' className={classes.image}/></div>
            ) : (
                <div>
                    <Grid container justify='flex-start'>
                        <Grid item>
                            <IconButton className={classes.add_button} size='small'><Icon fontSize='small'>add</Icon></IconButton>  
                        </Grid>
                    </Grid>
                </div>
            )}
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    root:{
        cursor:'pointer'
    },
    image_container:{
        
        width:64,
        height:64, 
        position:'relative'
    },
    image:{
        width:'100%',
        height:'100%',
        objectFit:'contain'
    },
    add_button:{
        marginLeft:8,
        background:theme.palette.primary.main,
        color:'white',
        padding:4,
        '&:hover':{
            background:theme.palette.primary.dark,
        }
    }
}))
 
export default QrCodeThumb;